module.exports = __webpack_public_path__ + "static/img/cmef-tx.bee3abcf.png";